export const initAnalytics = () => {
    const isProd = process.env.NODE_ENV === 'production';
    const enabled = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';
    const GA_ID = process.env.REACT_APP_GA_ID;
  
    if (!isProd || !enabled || !GA_ID) return;
  
    // Load GA script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
  
    // Init GA
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
  
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  };